<template>
  <div class="danger-600 spacex-4 vertical-centering">
    <ErrorIcon />
    <span>{{ error || $t('An error has occurred') }}</span>
  </div>
</template>

<script>
  import ErrorIcon from '@/assets/icons/error-red.svg';

  export default {
    name: 'ErrorAlert',
    components: {
      ErrorIcon,
    },
    props: {
      error: {
        type: String,
        default: '',
      },
    },
  };
</script>
